import { render, staticRenderFns } from "./procedure4.vue?vue&type=template&id=bb4db07a&scoped=true"
import script from "./procedure4.vue?vue&type=script&lang=js"
export * from "./procedure4.vue?vue&type=script&lang=js"
import style0 from "./procedure4.vue?vue&type=style&index=0&id=bb4db07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4db07a",
  null
  
)

export default component.exports